import ReplayGameModal from './replay-game-modal';
export default ReplayGameModal;
